import React from "react";

const OutTime = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M29.389 34c.427 0 .837-.169 1.14-.469.301-.3.471-.707.471-1.131V3.6c0-.424-.17-.831-.472-1.131A1.617 1.617 0 0029.388 2H6.834c-.427 0-.837.169-1.139.469-.302.3-.472.707-.472 1.131v28.8c0 .424.17.831.472 1.131.302.3.712.469 1.14.469h22.555zm-16.111-9.6L5.222 18l8.056-6.4v4.8h9.666v3.2h-9.666v4.8z"
            fill={fill}
        />
    </svg>
);

export default OutTime;
